import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    width: 100%;
  }

  :host(:last-child) a {
    border-bottom: none;
  }

  a {
    display: block;
    text-decoration: none;
    color: inherit;
    border-radius: var(--sds-size-radius-600);
    border-bottom: 1px solid var(--sds-color-border-default-default);
  }

  .card-content {
    display: flex;
    align-items: flex-start;
    gap: var(--sds-size-space-600);
    padding: var(--sds-size-space-600);
    border-radius: var(--sds-size-radius-600);
    background-color: inherit;
    transition: background-color 0.2s ease;
  }

  .card-content:hover {
    background-color: var(--sds-color-background-default-default);
  }

  .card-icon {
    display: flex;
    min-width: 40px;
    min-height: 40px;
    width: 40px;
    height: 40px;
    justify-content: center;
    align-items: center;
    gap: var(--sds-size-space-300);
    border-radius: var(--sds-size-radius-400);
    background-color: var(--sds-color-background-default-secondary-hover);
  }

  .card-text {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  .card-title {
    color: var(--sds-color-text-default-secondary);
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-body-size-medium);
    font-style: normal;
    font-weight: var(--sds-typography-weight-semibold);
    line-height: 100%;
  }

  .card-description {
    color: var(--sds-color-text-default-tertiary);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-small);
    font-style: normal;
    font-weight: var(--sds-typography-weight-regular);
    line-height: 150%;
  }
`;
